/**
 * @flow
 * @relayHash 127ee0d666ee6e293d9b89532ff60bbd
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ContractTemplateSignaturePermissionMode = "A_1" | "A_2" | "A_3" | "%future added value";
export type UpdateContractTemplateInput = {|
  id: string,
  name?: ?string,
  categories?: ?$ReadOnlyArray<?string>,
  ignoreVariablesErrors?: ?$ReadOnlyArray<?string>,
  signaturePermissionMode?: ?number,
  allowedSignerIds?: ?$ReadOnlyArray<?string>,
  specificSignerIds?: ?$ReadOnlyArray<?string>,
  contractValueLimitEnabled?: ?boolean,
  contractValueLimit?: ?any,
  signerOverrides?: ?$ReadOnlyArray<?SignerOverrideInput>,
  clientMutationId?: ?string,
|};
export type SignerOverrideInput = {|
  staffId: string,
  contractValueLimit: any,
|};
export type UpdateContractTemplateMutationVariables = {|
  input: UpdateContractTemplateInput
|};
export type UpdateContractTemplateMutationResponse = {|
  +updateContractTemplate: ?{|
    +contractTemplate: ?{|
      +id: string,
      +name: string,
      +docxFileName: string,
      +docxFileUrl: ?string,
      +samplePdfFileUrl: ?string,
      +categories: ?{|
        +edges: $ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +name: string,
          |}
        |}>
      |},
      +signaturePermissionMode: ContractTemplateSignaturePermissionMode,
      +allowedSigners: ?{|
        +edges: $ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +user: {|
              +fullName: ?string
            |},
          |}
        |}>
      |},
      +specificSigners: ?{|
        +edges: $ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +user: {|
              +fullName: ?string
            |},
          |}
        |}>
      |},
      +contractValueLimitEnabled: boolean,
      +contractValueLimit: ?number,
      +signerOverrides: ?$ReadOnlyArray<?{|
        +id: ?string,
        +staff: ?{|
          +id: string,
          +user: {|
            +fullName: ?string
          |},
        |},
        +contractValueLimit: ?any,
      |}>,
    |},
    +errors: ?any,
  |}
|};
export type UpdateContractTemplateMutation = {|
  variables: UpdateContractTemplateMutationVariables,
  response: UpdateContractTemplateMutationResponse,
|};
*/


/*
mutation UpdateContractTemplateMutation(
  $input: UpdateContractTemplateInput!
) {
  updateContractTemplate(input: $input) {
    contractTemplate {
      id
      name
      docxFileName
      docxFileUrl
      samplePdfFileUrl
      categories(orderBy: "name") {
        edges {
          node {
            id
            name
          }
        }
      }
      signaturePermissionMode
      allowedSigners {
        edges {
          node {
            id
            user {
              fullName
              id
            }
          }
        }
      }
      specificSigners {
        edges {
          node {
            id
            user {
              fullName
              id
            }
          }
        }
      }
      contractValueLimitEnabled
      contractValueLimit
      signerOverrides {
        id
        staff {
          id
          user {
            fullName
            id
          }
        }
        contractValueLimit
      }
    }
    errors
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateContractTemplateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "docxFileName",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "docxFileUrl",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "samplePdfFileUrl",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "categories",
  "storageKey": "categories(orderBy:\"name\")",
  "args": [
    {
      "kind": "Literal",
      "name": "orderBy",
      "value": "name"
    }
  ],
  "concreteType": "CategoryNodeConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "CategoryNodeEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "CategoryNode",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v3/*: any*/)
          ]
        }
      ]
    }
  ]
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "signaturePermissionMode",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fullName",
  "args": null,
  "storageKey": null
},
v10 = [
  (v2/*: any*/),
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "user",
    "storageKey": null,
    "args": null,
    "concreteType": "UserNode",
    "plural": false,
    "selections": [
      (v9/*: any*/)
    ]
  }
],
v11 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "StaffNodeEdge",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "StaffNode",
        "plural": false,
        "selections": (v10/*: any*/)
      }
    ]
  }
],
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "contractValueLimitEnabled",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "contractValueLimit",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "errors",
  "args": null,
  "storageKey": null
},
v15 = [
  (v2/*: any*/),
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "user",
    "storageKey": null,
    "args": null,
    "concreteType": "UserNode",
    "plural": false,
    "selections": [
      (v9/*: any*/),
      (v2/*: any*/)
    ]
  }
],
v16 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "StaffNodeEdge",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "StaffNode",
        "plural": false,
        "selections": (v15/*: any*/)
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateContractTemplateMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateContractTemplate",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateContractTemplatePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "contractTemplate",
            "storageKey": null,
            "args": null,
            "concreteType": "ContractTemplateNode",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "allowedSigners",
                "storageKey": null,
                "args": null,
                "concreteType": "StaffNodeConnection",
                "plural": false,
                "selections": (v11/*: any*/)
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "specificSigners",
                "storageKey": null,
                "args": null,
                "concreteType": "StaffNodeConnection",
                "plural": false,
                "selections": (v11/*: any*/)
              },
              (v12/*: any*/),
              (v13/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "signerOverrides",
                "storageKey": null,
                "args": null,
                "concreteType": "SignerOverrideType",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "staff",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "StaffNode",
                    "plural": false,
                    "selections": (v10/*: any*/)
                  },
                  (v13/*: any*/)
                ]
              }
            ]
          },
          (v14/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateContractTemplateMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateContractTemplate",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateContractTemplatePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "contractTemplate",
            "storageKey": null,
            "args": null,
            "concreteType": "ContractTemplateNode",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "allowedSigners",
                "storageKey": null,
                "args": null,
                "concreteType": "StaffNodeConnection",
                "plural": false,
                "selections": (v16/*: any*/)
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "specificSigners",
                "storageKey": null,
                "args": null,
                "concreteType": "StaffNodeConnection",
                "plural": false,
                "selections": (v16/*: any*/)
              },
              (v12/*: any*/),
              (v13/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "signerOverrides",
                "storageKey": null,
                "args": null,
                "concreteType": "SignerOverrideType",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "staff",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "StaffNode",
                    "plural": false,
                    "selections": (v15/*: any*/)
                  },
                  (v13/*: any*/)
                ]
              }
            ]
          },
          (v14/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateContractTemplateMutation",
    "id": null,
    "text": "mutation UpdateContractTemplateMutation(\n  $input: UpdateContractTemplateInput!\n) {\n  updateContractTemplate(input: $input) {\n    contractTemplate {\n      id\n      name\n      docxFileName\n      docxFileUrl\n      samplePdfFileUrl\n      categories(orderBy: \"name\") {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n      signaturePermissionMode\n      allowedSigners {\n        edges {\n          node {\n            id\n            user {\n              fullName\n              id\n            }\n          }\n        }\n      }\n      specificSigners {\n        edges {\n          node {\n            id\n            user {\n              fullName\n              id\n            }\n          }\n        }\n      }\n      contractValueLimitEnabled\n      contractValueLimit\n      signerOverrides {\n        id\n        staff {\n          id\n          user {\n            fullName\n            id\n          }\n        }\n        contractValueLimit\n      }\n    }\n    errors\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c6a1e4f72415b90798efefb64a05581f';
module.exports = node;
